<template>
  <section>
    <div v-if="!isMobile" class="container">
      <el-collapse-transition>
        <el-row class="home">
          <el-col :span="24" :lg="18">
            <!--  TODO move actions and filters in separate component -->
            <section
              v-if="!isMobile && canAction('action_shipping_list')"
              class="action_shipping_list"
            >
              <el-row :gutter="24" type="flex" align="middle">
                <el-col v-if="!isDispatcherRole" :span="3">
                  <div class="asl_div">
                    <img src="@/assets/img/add.svg" alt class="mr-10" />
                    <p>
                      <el-button
                        type="text"
                        @click="$router.push({ path: '/shipping/add' })"
                      >
                        Добавить
                      </el-button>
                    </p>
                  </div>
                </el-col>
                <el-col :span="12" class="asl_div">
                  <search-input
                    placeholder="Поиск по номеру, Названию организации (ИП), ИНН"
                    :value="search.value"
                    :disabled="isLoading"
                    @clear="clearFilter"
                    @search="filteredBidsList"
                    @input="onInput"
                  />
                </el-col>
                <el-col :span="9">
                  <div class="asl_div jc">
                    <el-button @click="getDate('today')">Сегодня</el-button>
                    <el-button @click="getDate('tomorrow')">Завтра</el-button>
                    <el-button @click="showMapBids = true">
                      Показать на карте
                    </el-button>
                    <div class="datepicker">
                      <el-date-picker
                        v-model="date"
                        :picker-options="pickerOpt"
                        value-format="yyyy-MM-dd"
                        clear-icon="false"
                        @change="getDate($event)"
                      />
                    </div>
                  </div>
                </el-col>
                <el-col :span="2" class="asl_div jc">
                  <el-button type="text" @click="setIsArchive">
                    {{ is_archive ? 'Скрыть' : 'Показать' }}<br />архивные
                  </el-button>
                </el-col>
              </el-row>
              <el-row
                :gutter="20"
                type="flex"
                align="middle"
                justify="space-between"
                class="mb-20"
              >
                <el-col :span="11">
                  <search-input
                    placeholder="Поиск по месту загрузки"
                    :value="load_point"
                    :disabled="isLoading"
                    width="100%"
                    @clear="clearSearch('load_point')"
                    @search="onRouteSearch"
                    @input="val => onRouteInput(val, 'load_point')"
                  />
                </el-col>
                <el-col :span="2">
                  <div class="">
                    <img src="@/assets/img/arrow-route.svg" alt="" />
                  </div>
                </el-col>
                <el-col :span="11">
                  <search-input
                    placeholder="Поиск по грузополучателям"
                    :value="cargo_receiver_name"
                    :disabled="isLoading"
                    width="100%"
                    @clear="clearSearch('cargo_receiver_name')"
                    @search="onRouteSearch"
                    @input="val => onRouteInput(val, 'cargo_receiver_name')"
                  />
                </el-col>
              </el-row>
              <el-row type="flex" align="middle">
                <el-col class="df ai-c fw-wrap mr-30">
                  <el-radio-group v-model="type_code">
                    <el-radio-button label="">Все заявки</el-radio-button>
                    <el-radio-button
                      v-for="type in typeCodesFilters"
                      :key="type.label"
                      :label="type.label"
                    >
                      {{ type.title }}
                    </el-radio-button>
                  </el-radio-group>
                </el-col>
                <el-checkbox v-model="active_days" class="w-auto mr-30">
                  только с активными днями
                </el-checkbox>
                <div class="df ai-c mr-30">
                  <el-checkbox
                    v-if="isAdminOrCeoRole || isDispatcherRole"
                    v-model="is_tudatka"
                    class="w-auto"
                    :true-label="1"
                    @change="onTudatka"
                  >
                    тудатки
                  </el-checkbox>
                </div>
                <div class="df ai-c mr-30">
                  <el-checkbox
                    v-model="show_only_unpaid"
                    class="w-auto"
                    :true-label="1"
                    :false-label="null"
                    @change="onPaid"
                  >
                    Не оплачено
                  </el-checkbox>
                </div>
              </el-row>
            </section>
            <div v-if="getBidIdLanding" class="home__btn-clear-landing-bid">
              <el-button type="danger" @click="handleClearBidIdLanding">
                Посмотреть все погрузки
              </el-button>
            </div>
            <shipping-list
              :bids-list="bidsList"
              :fetch-bids="prepareData"
              :is-archive="is_archive"
              :is-loading="isLoading"
              @close-day="handleCloseDay"
            />
            <div v-if="!isLoading" class="pagination">
              <pagination-custom :data="pagination" @changed="changePage" />
            </div>
          </el-col>
          <statistic-by-user v-if="canAction('statisticByUser')" />
        </el-row>
      </el-collapse-transition>
    </div>
    <component :is="homeMobileComponent" v-else @fetch="fetchBids" />
    <bids-on-map
      v-if="!isMobile"
      :bids-list="activeBidsListMap"
      :visible="showMapBids"
      :fetch-bids="prepareData"
      @fetch="fetchBids"
      @closed="showMapBids = false"
    />
  </section>
</template>

<script>
import { dateToFilter, isFutures, validateNumber } from '@/helpers/functions'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { pickerOpt, typeCodesFilters } from '@/datas/consts'
import BidsOnMap from '@/views/Home/Shipping/Modals/BidsOnMap'
import HomeMobile from '@/views/HomeMobile/index'
import NewHomeMobile from '@/views/NewHomeMobile/index'
import PaginationCustom from '@/components/Tables/PaginationCustom'
import SearchInput from '@/components/Shared/SearchInput'
import ShippingList from './Shipping/ShippingList'
import StatisticByUser from './StatisticByUser/StatisticByUser'
import axios from 'axios'

export default {
  name: 'Home',
  components: {
    BidsOnMap,
    StatisticByUser,
    ShippingList,
    HomeMobile,
    NewHomeMobile,
    SearchInput,
    PaginationCustom,
  },
  data() {
    return {
      search: {
        value: '',
        date: false,
      },
      active_days: false,
      pickerOpt,
      date: '',
      load_point: '',
      cargo_receiver_name: '',
      is_archive: false,
      currentPage: 1,
      cancelSource: null,
      org_performer_id: null,
      typeCodesFilters,
      showMapBids: false,
      is_tudatka: false,
      show_only_unpaid: null,
    }
  },
  computed: {
    ...mapGetters({
      getBids: 'bids/getBids',
      pagination: 'bids/getPagination',
      getType: 'bids/getTypeCode',
      getLoading: 'bids/getLoading',
      performers: 'organizations/getOrganizations',
      getBidIdLanding: 'bids/getBidIdLanding',
    }),
    isLoading() {
      return this.getLoading('Bid')
    },
    type_code: {
      get() {
        return this.getType
      },
      set(value) {
        this.setTypeCode(value)
        this.updateTypeCode(value)
      },
    },
    bidsList() {
      return this.active_days
        ? this.getBids.filter(b =>
            b.load_days.find(d => isFutures(d.load_date)),
          )
        : this.getBids
    },
    homeMobileComponent() {
      return this.isDriverRole ? NewHomeMobile : HomeMobile
    },
    activeBidsListMap() {
      return this.getBids.filter(b =>
        b.load_days.find(d => isFutures(d.load_date)),
      )
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        if (!this.isMobile) {
          if (to.query.archive !== from?.query.archive) {
            this.is_archive = Boolean(Number(to.query.archive))
          }
          if (to.query.value !== from?.query.value) {
            this.search.value = to.query.value
          }
          if (to.query.type_code !== from?.query.type_code) {
            this.type_code = to.query.type_code
          }
          if (to.query.currentPage !== from?.query.currentPage) {
            this.currentPage = validateNumber(to.query.currentPage)
              ? Number(to.query.currentPage)
              : 1
          }
          if (to.query.date !== from?.query.date) {
            this.search.date = to.query.date === 1 ? 1 : 0
          }
          if (to.query.org_performer_id !== from?.query.org_performer_id) {
            this.org_performer_id = validateNumber(to.query.org_performer_id)
              ? Number(to.query.org_performer_id)
              : null
          }

          this.prepareData()
        }
      },
    },
  },
  mounted() {
    this.fetchOrganizations({ can_be_performer: 1 })
  },
  methods: {
    ...mapActions({
      fetchOrganizations: 'organizations/fetchOrganizations',
      updateDayFields: 'bids/updateDayFields',
      fetchHome: 'bids/fetchHome',
    }),
    ...mapMutations('bids', ['updateTypeCode']),
    prepareData() {
      const data = {
        with_carrier_request: 1,
        is_archive: this.is_archive,
        search: this.search,
        page: this.currentPage,
        type_code: this.type_code,
        org_performer_id: this.org_performer_id,
        load_point: this.load_point,
        cargo_receiver_name: this.cargo_receiver_name,
        is_tudatka: this.is_tudatka,
        show_only_unpaid: this.show_only_unpaid,
      }

      this.fetchBids(data)
    },
    fetchBids(requestData = {}) {
      if (this.cancelSource) {
        this.cancelSource.cancel('Start new search, stop active search')
      }
      this.cancelSource = axios.CancelToken.source()

      const data = {
        ...requestData,
        user_type: this.userInfo.user_type,
        cancelToken: this.cancelSource.token,
      }

      this.fetchHome(data)
    },
    performerFilter(val) {
      this.routePush({ org_performer_id: val || null })
    },
    onInput(cur) {
      this.search.value = cur
    },
    setIsArchive() {
      this.is_archive = !this.is_archive
      this.routePush({
        archive: this.is_archive ? '1' : '0',
        currentPage: 1,
      })
    },
    filteredBidsList(searchValue) {
      this.search = {
        value: String(searchValue).trim(),
        date: false,
      }
      this.routePush({
        currentPage: 1,
        value: String(searchValue).trim(),
        date: 0,
      })
    },
    setTypeCode(val) {
      this.routePush({
        type_code: String(val).trim(),
        currentPage: 1,
      })
    },
    getDate(param) {
      const date = dateToFilter(param)

      if (date) {
        this.search = {
          value: String(date).trim(),
          date: true,
        }
        this.routePush({
          currentPage: 1,
          value: String(date).trim(),
          date: 1,
        })
      } else {
        this.clearFilter()
      }
    },
    clearFilter() {
      this.date = ''
      this.search = {
        value: '',
        date: false,
      }
      this.routePush({
        currentPage: 1,
        value: '',
        date: 0,
      })
    },
    clearSearch(field) {
      this[field] = ''
      this.onRouteSearch()
    },
    onRouteSearch() {
      if (this.currentPage === 1) {
        this.prepareData()
      } else {
        this.routePush({ currentPage: 1 })
      }
    },
    onTudatka() {
      if (this.currentPage === 1) {
        this.prepareData()
      } else {
        this.routePush({ currentPage: 1, is_tudatka: this.is_tudatka })
      }
    },
    onPaid() {
      if (this.currentPage === 1) {
        this.prepareData()
      } else {
        this.routePush({
          currentPage: 1,
          show_only_unpaid: this.show_only_unpaid,
        })
      }
    },
    onRouteInput(cur, field) {
      this[field] = cur
    },
    changePage(page) {
      this.routePush({ currentPage: String(page) })
    },
    routePush(obj = {}) {
      this.$router.push({
        name: 'Home',
        query: {
          ...this.$route.query,
          ...obj,
        },
      })
    },
    handleCloseDay(day) {
      this.updateDayFields({
        id: day.id,
        data: { status: day.status === 1 ? 0 : 1 },
        callback: this.callbackFunc,
      })
    },
    callbackFunc(isSuccess) {
      if (isSuccess) {
        this.$message.success('Статус дня успешно обновлен')
      }
      this.alert_day = !isSuccess
    },
    handleClearBidIdLanding() {
      this.$store.commit('bids/setBidIdLanding', null)
      this.prepareData()
    },
  },
}
</script>

<style lang="sass">
.home
  margin-bottom: 70px
  .mr-30
    margin-right: 30px !important
  .mr-10
    margin-right: 10px
  .mb-20
    margin-bottom: 20px
  .el-table th
    display: none !important
  .err-p
    color: #ff0000
    font-size: 16px
    margin: 15px
  .el-card
    padding: 0 20px 25px
    .el-card__body
      padding: 0 !important
  .more
    text-align: center
    &:hover
      cursor: pointer
  .action_shipping_list
    padding-bottom: 10px
    .datepicker
      width: 48px
      height: 38px
      display: flex
      .el-date-editor.el-input
        width: 100%
      .el-input__inner
        display: none
      .el-input__prefix
        font-size: 38px
        color: #000
      &:hover
        cursor: pointer
    .asl_div
      display: flex
      justify-content: center
      align-items: center
      &.js
        justify-content: flex-start
      &.jc
       justify-content: space-between
    .add-search span
      white-space: nowrap
      overflow: hidden
  .bc_button
    float: right
    padding: 3px 0
  &__btn-clear-landing-bid
    margin-bottom: 20px
.el-dialog
  .el-breadcrumb
    display: none
  .el-col-sm-18
    width: 100%
  .create_bids
    display: block !important
  .dialog-footer
    button
      margin-top: 15px
.pagination
  text-align: right
  margin: 30px 0 20px
</style>
